import Vue from 'vue';
import VueRouter from 'vue-router';

// routes
import start from '@/router/routes/start';
import aboutUs from '@/router/routes/aboutUs';
import services from '@/router/routes/services';
import careers from '@/router/routes/careers';
import expertise from '@/router/routes/expertise';
import blog from '@/router/routes/blog';
import contactUs from '@/router/routes/contactUs';

const Main = () => import(/* webpackChunkName: "Main" */ '@/views/Main');

Vue.use(VueRouter);

// Solve the problem that vue-router in the navigation bar of
// ElementUI reports an error when repeatedly clicking the menu in version 3.0 or above
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/',
    redirect: '/Home',
    component: Main,
    children: [
      start,
      aboutUs,
      services,
      careers,
      expertise,
      blog,
      contactUs,
    ],
  },
  {
    path: '*',
    redirect: '/Home',
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
